export default __webpack_public_path__ + "static/media/EBay_logo.1f9f1e96.svg";